import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnIntegrationType } from './integration-type';

export class SnIntegration<Meta = any, Organization = unknown> extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public clientId: string;

  @Expose()
  public organization: Organization;

  @Expose()
  @Type(() => SnIntegrationType)
  public integrationType: SnIntegrationType;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public meta: Meta;

  @Expose()
  public status: any;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
